/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.logo-container[_ngcontent-%COMP%]{padding:5px 0 5px 5px}.page-heading[_ngcontent-%COMP%]{padding:10px 0}.action-container[_ngcontent-%COMP%]{padding:1rem}.status-container[_ngcontent-%COMP%]{padding:0 1rem 1rem}.status-container[_ngcontent-%COMP%]   .error-container[_ngcontent-%COMP%]{display:flex;flex-direction:row!important;align-items:baseline;gap:20px}.status-container[_ngcontent-%COMP%]   .top-padding[_ngcontent-%COMP%]{padding-top:1rem}"];
export { styles as styles };
